export default {
  primary: 'Primaria',
  secondary: 'Secundaria',
  1: 'Primaria',
  2: 'Secundaria',
  and: 'y'
}

export const en = {
  primary: 'Elementary',
  secondary: 'Secondary',
  1: 'Elementary',
  2: 'Secondary',
  and: 'and'
}

export const ca = {
  primary: 'Primària',
  secondary: 'Secundària',
  1: 'Primària',
  2: 'Secundària',
  and: 'y'
}
